import { useState, useEffect } from 'react';

const useKeyDown = () => {
    const [key, setKey] = useState('');
    const handleDown = ({ key }: KeyboardEvent) => setKey(key);
    const handleUp = () => setKey('');
    useEffect(() => {
        window.addEventListener('keydown', handleDown);
        window.addEventListener('keyup', handleUp);
        return () => {
            window.removeEventListener('keydown', handleDown);
            window.removeEventListener('keyup', handleUp);
        };
    }, []);
    return key;
};

export default useKeyDown;
